import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { getOtaTask, recoverTask } from '@blade-sxp/ota-management/api/index';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import colors from '@/styles/color.scss';
let default_1 = class extends Vue {
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    colors = colors;
    taskId = '';
    keyword = '';
    devicesList = [];
    // 过滤参数
    deviceStatusList = '';
    taskStatusList = '';
    listLoading = false;
    /**
     *@Description: 筛选向后段发送请求
     *@Date: 2020-09-10 18:20:13
     */
    get taskStatusFilter() {
        return [
            { text: this.$t('succeed'), value: 'SUCCESS' },
            { text: this.$t('failure'), value: 'FAIL' },
            { text: this.$t('updating'), value: 'DOING' },
            { text: this.$t('toUpdate'), value: 'WAITING' },
            { text: this.$t('cancel'), value: 'CANCEL' },
        ];
    }
    get deviceStatusFilter() {
        return [
            { text: this.$t('online'), value: 'ON_LINE' },
            { text: this.$t('offline'), value: 'OFF_LINE' },
        ];
    }
    getFirstKey(obj) {
        for (let key in obj) {
            return key;
        }
    }
    handleFilterChange(filters) {
        let firstKey = this.getFirstKey(filters);
        if (firstKey) {
            if (firstKey === 'diviceStatusList') {
                this.deviceStatusList = filters[firstKey][0];
            }
            else {
                this.taskStatusList = filters[firstKey][0];
            }
            this.pagination.page = 1;
            // 条件筛选待实现
            this.refresh();
        }
    }
    handleSearch() {
        this.refresh();
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.pagination.page = 1;
        this.refresh();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.refresh();
    }
    /**
     *@Description: 获取设备列表
     *@Date: 2020-09-10 18:17:12
     */
    getDevicesList() {
        this.listLoading = true;
        let data = {
            keyword: this.keyword,
            page: this.pagination.page,
            size: this.pagination.size,
            taskId: this.taskId,
            deviceStatus: this.deviceStatusList,
            taskExecuteStatus: this.taskStatusList,
        };
        getOtaTask(data)
            .then((resp) => {
            this.devicesList = resp?.data?.data?.list || [];
            this.pagination.total = resp?.data?.data?.total;
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        })
            .finally(() => {
            this.listLoading = false;
        });
    }
    handleRecover(sid) {
        const id = sid.toString() || '';
        recoverTask(id)
            .then((resp) => {
            this.$message({
                message: resp.data.message,
                type: 'success',
            });
            this.refresh();
        })
            .catch((err) => {
            let error = err.toString() || '';
            if (error.indexOf('Error:') !== -1) {
                error = error.split('Error:').join('');
            }
            this.$alert(error, this.$t('reason').toString(), {
                confirmButtonText: this.$t('common.confirm').toString(),
            });
        });
    }
    showFailReason(reason) {
        this.$alert(reason, this.$t('reason').toString(), {
            confirmButtonText: this.$t('common.confirm').toString(),
        });
    }
    refresh() {
        this.getDevicesList();
    }
    handleClear() {
        this.keyword = '';
    }
    mounted() {
        const query = this.$route.query;
        const { taskId } = query;
        if (taskId) {
            this.taskId = taskId + '';
        }
        this.refresh();
    }
};
default_1 = __decorate([
    Component({
        name: 'deviceList',
        components: { AuthItem },
        filters: {
            toFormat: (num) => {
                return num ? moment(num).format('YYYY-MM-DD hh:mm:ss') : '';
            },
        },
        i18n: {
            messages: {
                'en-us': {
                    unusual: 'unusual',
                    online: 'Online',
                    offline: 'Offline',
                    searchPlaceHolder: 'Device Name / Serial Number',
                    search: 'Search',
                    Numbering: 'index',
                    devcieName: 'Devcie Name',
                    devcieType: 'Devcie type',
                    currentPackageVersion: 'Version',
                    deviceStatus: 'Device Status',
                    normal: 'Normal',
                    UnableToConnect: 'Unable to connect',
                    connecting: 'connecting',
                    disable: 'disable',
                    taskStatus: 'Task status',
                    succeed: 'Update Success',
                    failure: 'Update Fail',
                    updating: 'Updating',
                    toUpdate: 'Pending',
                    cancel: 'Canceled',
                    Reissue: 'Re-execute',
                    filtersData: [
                        { text: 'success', value: 'OK' },
                        { text: 'fail', value: 'FAIL' },
                        { text: 'updating', value: 'DOING' },
                    ],
                    deviceStatusFilter: [
                        { text: 'offline', value: '0' },
                        { text: 'online', value: '1' },
                        { text: 'unusual', value: '2' },
                    ],
                    exportedData: 'Please select the data to be exported',
                    taskExexuteStatus: 'Task Status',
                    snNum: 'Serial Number',
                    startTime: 'Task Execution Time',
                    reason: 'Reason',
                },
                zh: {
                    online: '在线',
                    offline: '离线',
                    unusual: '异常',
                    searchPlaceHolder: '设备名称/SN码',
                    search: '搜索',
                    Numbering: '编号',
                    devcieName: '设备名称',
                    devcieType: '设备类型',
                    currentPackageVersion: '当前版本',
                    deviceStatus: '设备状态',
                    normal: '正常',
                    UnableToConnect: '无法连接',
                    connecting: '连接中...',
                    disable: '停用',
                    taskStatus: '任务状态',
                    succeed: '更新成功',
                    failure: '更新失败',
                    updating: '更新中',
                    toUpdate: '待更新',
                    cancel: '取消更新',
                    Reissue: '重新下发',
                    filtersData: [
                        { text: '更新成功', value: 'OK' },
                        { text: '更新失败', value: 'FAIL' },
                        { text: '更新中', value: 'DOING' },
                    ],
                    deviceStatusFilter: [
                        { text: '离线', value: '0' },
                        { text: '在线', value: '1' },
                        { text: '异常', value: '2' },
                    ],
                    exportedData: '请选择需要导出的数据',
                    taskExexuteStatus: '任务状态',
                    snNum: '设备SN码',
                    startTime: '任务执行时间',
                    reason: '原因',
                },
            },
        },
    })
], default_1);
export default default_1;
